export default __webpack_public_path__ + "static/media/telegram.7022966b.png";